import { doc, updateDoc } from "@firebase/firestore";
import { db } from "../../../firebase";
import HelperForMetaData from "../../../Helpers/HelperForMetaData";

const UpdateExamForResult = async (ResultID, ExamID) => {
  try {
    const ExamDocument = doc(db, "Exams", ExamID);

    const data = {
      ResultID: ResultID,
      ...HelperForMetaData({}),
    };

    delete data.createdAt;
    delete data.createdBy;

    await updateDoc(ExamDocument, data);

    return true;
  } catch (error) {
    console.log(error);

    return false;
  }
};

export default UpdateExamForResult;
